import type { ListProps } from './List.types';

import { S } from './List.styles';

export const List = ({ items }: ListProps) => {
  return (
    <S.Container>
      {items.map((item) => (
        <S.Item key={item}>{item}</S.Item>
      ))}
    </S.Container>
  );
};
